import { lazy } from 'react';

// Map of icon names to their dynamic import.
export const skillIcon = {
	skill: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon" */ '@atlaskit/icon-lab/core/skill'
		),
	assets: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-assets" */ '@atlaskit/icon/core/assets'
		),
	add: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-add" */ '@atlaskit/icon/core/add'
		),
	'chart-bar-line': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-chart-bar-line" */ '@atlaskit/icon-lab/core/chart-bar-line'
		),
	'ai-generative-text': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-ai-generative-text" */ '@atlaskit/icon-lab/core/ai-generative-text'
		),
	'work-item': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-work-item" */ '@atlaskit/icon/core/work-item'
		),
	'lock-locked': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-lock-locked" */ '@atlaskit/icon/core/lock-locked'
		),
	'chart-pie': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-chart-pie" */ '@atlaskit/icon/core/chart-pie'
		),
	plan: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-plan" */ '@atlaskit/icon-lab/core/plan'
		),
	settings: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-settings" */ '@atlaskit/icon/core/settings'
		),
	'project-status': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-project-status" */ '@atlaskit/icon/core/project-status'
		),
	'merge-success': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-merge-success" */ '@atlaskit/icon/core/merge-success'
		),
} as const;

export type SkillIconName = keyof typeof skillIcon;

export const defaultIcon = skillIcon.skill;

type SkillIconMap = {
	[K in SkillIconName]: React.LazyExoticComponent<
		Awaited<ReturnType<(typeof skillIcon)[K]>>['default']
	>;
};

export const skillIconMap = Object.fromEntries(
	Object.entries(skillIcon).map(([key, loader]) => [key, lazy(loader)]),
) as SkillIconMap;

export const DefaultSkillIcon = skillIconMap.skill;
